<div id="login" class="float-panel lg-form-container" fxLayout="column">

    <div id="login-form-wrapper" class="lg-form-wrapper" fxLayout="column" fxLayoutAlign="center center" *ngcIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

        <div id="login-form" class="lg-form" *ngcIfOnDom fxLayout="column" fxLayoutAlign="center center">

            <div id="login-form-block">
                <mat-progress-bar *ngIf="loading$ | async" class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>

                <div class="logo" alt="logo"></div>

                <ngc-credentials-login *ngIf="isCredentialsLoginView"
                                       [loginForm]="loginForm"
                                       [loginFormErrors]="loginFormErrors"
                                       [loading$]="loading$"
                                       [supportUrl]="supportUrl"
                                       (formSubmit)="onFormSubmit($event)"
                >
                </ngc-credentials-login>

                <ngc-mfa-login [ngStyle]="{'display': isMFALoginView ? 'block': 'none'}"
                               [loginForm]="loginForm"
                               [loginFormErrors]="loginFormErrors"
                               [loading$]="loading$"
                               [phoneNumber]="MFAPhone"
                               [isMFALoginView]="isMFALoginView"
                               (formSubmit)="onFormSubmit($event)"
                               (backToCredentialsLogIn)="onBackToCredentialsLogIn()"
                               (sendCodeAgain)="onSendCodeAgain()"
                               (turnOnRecoveryCodeLoginView)="onTurnOnRecoveryCodeLoginView()"
                >
                </ngc-mfa-login>

                <ngc-recovery-code-login *ngIf="isRecoveryCodeLoginView"
                                         [loginForm]="loginForm"
                                         [loginFormErrors]="loginFormErrors"
                                         [loading$]="loading$"
                                         [supportUrl]="supportUrl"
                                         (formSubmit)="onFormSubmit($event)"
                                         (backToMFALogIn)="onBackToMFALogIn()"
                >
                </ngc-recovery-code-login>

                <ngc-mfa-setup *ngIf="isMFASetupView"
                               [loading$]="loading$"
                               (backToCredentialsLogIn)="onBackToCredentialsLogIn()"
                               (performCredentialsLogin)="performLogin()"
                               (turnOnCredentialsLoginView)="onTurnOnCredentialsLoginView()"
                >
                </ngc-mfa-setup>
            </div>

            <!--<div class="separator">
                <span class="text">OR</span>
            </div>

            <button mat-raised-button class="edutone">
                Login with EduTone
            </button>-->

            <!--<div class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">Don't have an account?</span>
                <a class="link" [routerLink]="'/pages/auth/register'">Create an account</a>
            </div>-->

        </div>

    </div>

    <ngc-footer-page *ngcIfOnDom [textColor]="'white'"></ngc-footer-page>

</div>
